import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';

import { entiyFeatureType } from 'types';
import FeatureItem from './components/FeatureItem';

import './style.scss';

const FeaturesList = ({ features }) => (
  <table styleName="list">
    <tbody data-test="features-list">
      {features.map(feature => (
        <FeatureItem key={uuid()} feature={feature} />
      ))}
    </tbody>
  </table>
);

FeaturesList.propTypes = {
  features: PropTypes.arrayOf(entiyFeatureType).isRequired,
};

export default FeaturesList;
